// extracted by mini-css-extract-plugin
module.exports = {"languageSelector":"LanguageSelector_languageSelector__WtqNz","select":"LanguageSelector_select__HOxGb"};